module.exports = __webpack_public_path__ + "img/news8-1.ccb7f521.png";